import { CONSTANTS } from '@/types/enum/constants'

const getIsUserAdminSchoolBackOffice = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles.find(value => CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_ADMIN == value) || false

export default getIsUserAdminSchoolBackOffice
